import { ItemInstance } from '@headless-tree/core';
import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { ListSectionDateHeader } from 'shared/components/ui/list-section-date-header';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';
import { parseDateKey } from 'shared/utils/format-date-key';

import * as Styled from './deadline-header.style';

export type DeadlineHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
};

const noDeadlineSectionID = 'no-deadline';

export const DeadlineHeader: React.FC<DeadlineHeaderProps> = ({ item }) => {
  const { t } = useTranslation();
  const sectionId = item.getItemData()?.sourceId;

  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  const date = useMemo(() => {
    if (!sectionId) {
      return undefined;
    }
    const _date = parseDateKey(sectionId);
    return isNaN(_date.getTime()) ? undefined : _date;
  }, [sectionId]);

  if (!sectionId) {
    return null;
  }

  return (
    <Styled.Container>
      {date ? (
        <ListSectionDateHeader date={date} />
      ) : (
        <Typography variant="h6" component="span">
          {sectionId === noDeadlineSectionID
            ? t('general.labels.no-deadline')
            : t('general.sections.overdue.title')}
        </Typography>
      )}

      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.Container>
  );
};
